import { useQuery } from '@hooks/reactQuery';

import { getLimenetCellsByCrowdcellId, getNokiaCellsBySiteId } from '@api/manageCell';

import { ISiteProfile } from '@interfaces/cells/siteProfile';

import { EVendorsValues, TTechnologiesValues } from '@enums/common';

import { LIMENET_CELLS, NOKIA_CELLS } from '@constants/queryKeys';

interface ILimenetCellsParams {
	technology?: TTechnologiesValues;
	sites: Array<ISiteProfile>;
}

export const useSiteCells = (params: ILimenetCellsParams) => {
	const {
		sites,
		technology,
	} = params || {};

	const limenetSites = sites.filter(site => {
		return site.vendor.name === EVendorsValues.limenet && site.technologies.some(tech => tech.name === technology);
	});

	const nokiaSites = sites.filter(site => {
		return site.vendor.name === EVendorsValues.nokia && site.technologies.some(tech => tech.name === technology);
	});

	const { data: limenetCells } = useQuery({
		queryKey: [LIMENET_CELLS, limenetSites, technology],
		queryFn: () => {
			if (!technology) return [];

			return Promise.all(limenetSites
				.filter(site => site?.crowdCell)
				.map(site => {
					return getLimenetCellsByCrowdcellId(technology, site.crowdCell.id);
				}));
		},
		enabled: [limenetSites?.length, technology],
	});

	const { data: nokiaCells } = useQuery({
		queryKey: [NOKIA_CELLS, nokiaSites, technology],
		queryFn: () => {
			if (!technology) return [];

			return Promise.all(nokiaSites.map(site => getNokiaCellsBySiteId(technology, site.id)));
		},
		enabled: [nokiaSites?.length, technology],
	});

	return {
		limenetCells: limenetCells || [],
		nokiaCells: nokiaCells || [],
	};
};
